import { date, object, string } from "yup";

export enum PaymentDetailsStepInputFields {
  PaymentDescription = "paymentDescription",
  ScheduledPaymentProcessDate = "scheduledPaymentProcessDate",
}

export type InitialValues = {
  [PaymentDetailsStepInputFields.PaymentDescription]: string;
  [PaymentDetailsStepInputFields.ScheduledPaymentProcessDate]: Date | null;
};

export const PaymentDetailsInputObject = () =>
  object().shape({
    [PaymentDetailsStepInputFields.PaymentDescription]: string().max(
      35,
      "Must be at most 35 characters",
    ),
    [PaymentDetailsStepInputFields.ScheduledPaymentProcessDate]: date().required(
      "A payment process date is required",
    ),
  });
